import { Badge } from '@/components/ui/badge';
import type { VariantProps } from 'class-variance-authority';
import type { badgeVariants } from '@/components/ui/badge';
import { CheckCircle2, AlertCircle, Clock, Circle, CircleCheck, LoaderCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export type StatusType = 'SUCCESS' | 'FAILED' | 'INPROGRESS' | 'PENDING' | 'ACTIVE' | 'INACTIVE';

interface SourceStatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}

const statusConfig: Record<
  StatusType,
  {
    label: string;
    variant: VariantProps<typeof badgeVariants>['variant'];
    icon: LucideIcon;
  }
> = {
  SUCCESS: {
    label: 'Synced',
    variant: 'success',
    icon: CircleCheck
  },
  FAILED: {
    label: 'Failed',
    variant: 'destructive',
    icon: AlertCircle
  },
  INPROGRESS: {
    label: 'Syncing',
    variant: 'info',
    icon: LoaderCircle
  },
  PENDING: {
    label: 'Pending',
    variant: 'secondary',
    icon: Clock
  },
  ACTIVE: {
    label: 'Active',
    variant: 'success',
    icon: CheckCircle2
  },
  INACTIVE: {
    label: 'Inactive',
    variant: 'secondary',
    icon: Circle
  }
};

export function SourceStatusBadge({ status, label, className }: SourceStatusBadgeProps) {
  const config = statusConfig[status] || {
    label: status,
    variant: 'secondary' as const,
    icon: Circle
  };

  const Icon = config.icon;
  const isInProgress = status === 'INPROGRESS';

  return (
    <Badge variant={config.variant} className={cn('pl-1 pr-1.5 py-1 text-[10px]', className)}>
      <Icon className={cn('mr-0 size-3', isInProgress && 'animate-spin')} />
      {label || config.label}
    </Badge>
  );
}
